import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=31fb7e69&scoped=true"
import script from "./UserRoleTable.vue?vue&type=script&lang=js"
export * from "./UserRoleTable.vue?vue&type=script&lang=js"
import style0 from "./UserRoleTable.vue?vue&type=style&index=0&id=31fb7e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb7e69",
  null
  
)

export default component.exports